<template>
 <div>
    <div class="row-item" v-for="shop in shopList" :key="shop.id">
      <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
      <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
      <el-select
        :value="valueMap[shop.id]"
        :loading="loading[shop.id]"
        value-key="sizeTemplateId"
        name-key="sizeTemplateName"
        clearable
        @visible-change="isShow => visibleSelect(isShow, shop)"
        @change="v => selectChange(v, shop.id)"
      >
        <el-option v-for="item in optionsMap[shop.id]" :key="item.sizeTemplateId" :label="item.sizeTemplateName" :value="item"> </el-option>
      </el-select>
      <span v-if="getFail[shop.id]" style="color: red;margin-left: 10px; font-size: 12px;">店铺授权已失效</span>
    </div>
  </div>
</template>

<script>
import { getSizecharts } from '@/servers/prod/center/temu.js';
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      valueMap: {},
      sizechartList:[],
      optionsMap: {},
      getFail: {},
      loading: {},
      initValueMaped: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.valueMap = {};
        (v || []).forEach(item => {
          const { shopId,sizeTemplateId,sizeTemplateName } = item || {};
          if (shopId && sizeTemplateId) {
            this.$set(this.valueMap, shopId, item);
          }
        });
        // if (!this.initValueMaped) { // 只在第一次加载的时候判断，如果没值，默认选中第一个
        //   this.initValueMaped = true;
        //   this.shopList.forEach(shop => {
        //     if (!this.valueMap[shop.id]?.sizeTemplateName) {
        //       this.getList(shop);
        //     }
        //   });
        // }
      },
    },
  },
  methods: {
    visibleSelect(isShow, shop) {
      if (!isShow) return;
      if (!this.optionsMap[shop.id]?.length) {
        this.getList(shop);
      }
    },
    selectChange(v, shopId) {
      this.valueMap[shopId] = v;
      this.valueChange();
    },
    valueChange() {
      let valueList = Object.values(this.valueMap).filter(Boolean);
      this.$emit('change', valueList);
    },
    // 获取
    async getList(shop) {
      if(![2, 3].includes(shop.state)) return
      try {
        const shopId = shop.id;
        this.$set(this.loading, shopId, true);
        const data = await getSizecharts({ shopId }, { isNeedFailNotice: true });
        this.loading[shopId] = false;
        this.$set(this.getFail, shopId, !data);
        let templateList = data?.sizeSpecDataList || [];
        if (!templateList.length) return;
        const list = templateList.map(item => {
          return {
            shopId,
            sizeTemplateId: item.businessId,
            sizeTemplateName: item.name,
          };
        });

        if (this.valueMap[shopId]) {
          const findItem = list.find(item => item.sizeTemplateId === this.valueMap[shopId].sizeTemplateId);
          this.$set(this.valueMap, shopId, findItem || list[0]);
        } else {
          this.$set(this.valueMap, shopId, list[0]);
        }
        this.valueChange();
        this.$set(this.optionsMap, shopId, list);
      } catch (error) {
        console.log(error, '-----error');
      }
    },
  },
  created(){
  }
}
</script>

<style lang="scss" scoped>
.row-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>